import React, { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileSpreadsheet, CheckCircle2, Send } from "lucide-react";
import SpotGasUploadCard from "@/components/SpotGasUploadCard";

export default function AdminUpload() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [sendNotif, setSendNotif] = useState(true);
  const inputRef = useRef(null);

  const upload = async () => {
    if (!file) return;
    setBusy(true); setResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("auto_publish", "true");
      fd.append("send_notification", sendNotif ? "true" : "false");
      const { data } = await api.post("/excel/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(data);
      toast.success("File importato con successo");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Caricamento Excel</h1>
        <p className="text-sm text-slate-500 mt-1">Importa file Energy Monitor.xlsx (fogli TTF, PSV, Power, Dashboard).</p>
      </div>

      <div className="card-elevated p-8">
        <div
          onClick={() => inputRef.current?.click()}
          onDrop={(e) => { e.preventDefault(); setFile(e.dataTransfer.files[0]); }}
          onDragOver={(e) => e.preventDefault()}
          className="border-2 border-dashed border-slate-300 hover:border-blue-500 hover:bg-blue-50/50 rounded-xl p-10 text-center cursor-pointer transition"
          data-testid="upload-dropzone"
        >
          <FileSpreadsheet className="mx-auto text-blue-600 mb-3" size={40} />
          {file ? (
            <div>
              <div className="font-semibold text-slate-900">{file.name}</div>
              <div className="text-xs text-slate-500">{(file.size / 1024).toFixed(1)} KB</div>
            </div>
          ) : (
            <>
              <div className="font-semibold text-slate-900">Trascina qui il file Excel</div>
              <div className="text-xs text-slate-500 mt-1">oppure clicca per selezionarlo (.xlsx)</div>
            </>
          )}
          <input ref={inputRef} type="file" accept=".xlsx" hidden onChange={(e) => setFile(e.target.files[0])} data-testid="upload-input" />
        </div>

        <div className="mt-5 flex items-center gap-2">
          <input id="sn" type="checkbox" checked={sendNotif} onChange={(e) => setSendNotif(e.target.checked)} />
          <label htmlFor="sn" className="text-sm text-slate-700">Invia notifica ai clienti dopo la pubblicazione</label>
        </div>

        <div className="mt-6 flex gap-2">
          <button disabled={!file || busy} onClick={upload} className="btn-brand flex items-center gap-2" data-testid="upload-submit">
            <Upload size={16} /> {busy ? "Importazione…" : "Pubblica dati"}
          </button>
          {file && !busy && (
            <button onClick={() => { setFile(null); setResult(null); }} className="text-sm px-4 border border-slate-200 rounded-lg hover:bg-slate-100">Reset</button>
          )}
        </div>

        {result && (
          <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-xl">
            <div className="flex items-center gap-2 text-green-800 font-semibold"><CheckCircle2 size={18} /> Importazione completata</div>
            <div className="text-xs text-green-700 mt-2 space-y-0.5">
              <div>Fogli importati: <span className="font-semibold">{(result.sheets_found || []).join(", ")}</span></div>
              <div>Fogli ignorati: <span className="font-semibold">{(result.sheets_ignored || []).join(", ") || "—"}</span></div>
              <div>Righe prezzi importate: <span className="font-semibold">{result.market_prices_count}</span></div>
              <div>Indicatori dashboard: <span className="font-semibold">{result.dashboard_indicators_count}</span></div>
            </div>
          </div>
        )}
      </div>

      {/* Card upload PSV/TTF Day Ahead Mid */}
      <SpotGasUploadCard />
    </div>
  );
}
